<template>
  <div>
    <h1 class="text-6xl tracking-wider">mtrl</h1>
  </div>
</template>

<script>
  export default {
    name: "Home"
  }
</script>

<style scoped>

</style>
